import { render, staticRenderFns } from "./MonitoraggioEcgEdit.vue?vue&type=template&id=135c3126&scoped=true"
import script from "./MonitoraggioEcgEdit.vue?vue&type=script&lang=js"
export * from "./MonitoraggioEcgEdit.vue?vue&type=script&lang=js"
import style0 from "./MonitoraggioEcgEdit.vue?vue&type=style&index=0&id=135c3126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c3126",
  null
  
)

export default component.exports